module.exports = __webpack_public_path__ + "img/keuntungan@3x.178b6acc.png";